(function () {
  if (window.__douxcouProductSections) return;
  window.__douxcouProductSections = true;

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-atc-trigger]");
    if (!trigger) return;
    const atc = document.getElementById("main-atc");
    if (atc) {
      e.preventDefault();
      atc.click();
      return;
    }
    if (trigger.getAttribute("href") === "#") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  });

  class LoopVideo extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector("video");
      if (!video) return;
      if (!("IntersectionObserver" in window)) {
        if (video.dataset.src) video.src = video.dataset.src;
        return;
      }
      video.muted = true;
      this.near = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          if (video.dataset.poster) video.poster = video.dataset.poster;
          if (video.dataset.src) video.src = video.dataset.src;
          video.removeAttribute("data-src");
          this.near.disconnect();
        },
        { rootMargin: "400px 0px" },
      );
      this.near.observe(video);
      this.io = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) video.play().catch(() => {});
          else video.pause();
        },
        { threshold: 0.25 },
      );
      this.io.observe(video);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.near) this.near.disconnect();
    }
  }
  if (!customElements.get("loop-video")) customElements.define("loop-video", LoopVideo);

  class TestimonialsSlider extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector("[data-slider-list]");
      if (!this.list) return;
      this.slides = [...this.list.children];
      this.dots = [...this.querySelectorAll("[data-slider-dot]")];
      this.prev = this.querySelector("[data-slider-prev]");
      this.next = this.querySelector("[data-slider-next]");
      this.active = 0;

      this.onScroll = () => {
        const first = this.slides[0];
        if (!first) return;
        const step = first.offsetWidth + 15;
        const i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.list.scrollLeft / step)));
        if (i !== this.active) this.setActive(i);
      };
      this.list.addEventListener("scroll", this.onScroll, { passive: true });
      this.dots.forEach((dot, i) => dot.addEventListener("click", () => this.goTo(i)));
      if (this.prev) this.prev.addEventListener("click", () => this.goTo(this.active - 1));
      if (this.next) this.next.addEventListener("click", () => this.goTo(this.active + 1));
      this.setActive(0);
    }
    disconnectedCallback() {
      if (this.list && this.onScroll) this.list.removeEventListener("scroll", this.onScroll);
    }
    goTo(i) {
      const slide = this.slides[i];
      if (slide) this.list.scrollTo({ left: slide.offsetLeft - this.list.offsetLeft, behavior: "smooth" });
    }
    setActive(i) {
      this.active = i;
      this.dots.forEach((dot, n) => {
        const on = n === i;
        dot.style.opacity = on ? "1" : "0.3";
        dot.style.transform = on ? "scale(1.4)" : "";
        dot.setAttribute("aria-current", on ? "true" : "false");
      });
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.slides.length - 1;
    }
  }
  if (!customElements.get("testimonials-slider")) customElements.define("testimonials-slider", TestimonialsSlider);
})();
